import { EventEmitter, Injectable, Output } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ShimmerLoadingService {
  @Output() loading: EventEmitter<any> = new EventEmitter();
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  constructor() { }
}
